import { render } from "./budgets-modal.vue?vue&type=template&id=3e9c1aa1"
import script from "./budgets-modal.vue?vue&type=script&lang=js"
export * from "./budgets-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__